export default __webpack_public_path__ + "static/media/widget-decrease.71189ad6.svg";